// extracted by mini-css-extract-plugin
export default {"band":"band---L6LDf","stat":"stat---L14RH"};